import { createContext } from "react";

/**
 * When the SelectionOption is rendered inside SelectionOptionModal, this context
 * exposes the modal's sticky-header slot DOM node. SelectionOptionPresentational
 * portals its SelectionOptionHeader into that node so the header stays pinned to
 * the top of the modal while the body scrolls.
 *
 * `null` when not inside a SelectionOptionModal — header renders inline as usual.
 */
export const SelectionOptionModalHeaderSlotContext = createContext<HTMLElement | null>(null);
